import React from 'react';
import { motion } from 'framer-motion';
export function StorySection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto text-center" data-id="element-250">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} data-id="element-251">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-252">
          ¿Cuántos domingos más vas a terminar sin saber qué cocinar mañana?
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-blue-100 leading-relaxed" data-id="element-253">
          <p className="text-2xl md:text-3xl font-semibold text-gold-400 py-4" data-id="element-254">
            No es falta de ganas. Es falta de un sistema.
          </p>
        </div>
      </motion.div>
    </section>;
}